import { isDate, parse } from "date-fns";
import moment from "moment";

export const formatDate = (value: string | number, format?: string) =>
  value ? moment(value).format(format || "DD/MM/YYYY") : "";

export const formatDateTime = (value: string | number, format?: string) =>
  moment(value).format(format || "DD/MM/YYYY HH:mm");

export const parseDateString = (_, originalValue) =>
  isDate(originalValue)
    ? originalValue
    : parse(originalValue, "yyyy-MM-dd", new Date());

export const getPreviousDate = () => {
  const today = new Date();
  const previousDate = today.getDate() - 1;
  return new Date(today.getFullYear(), today.getMonth(), previousDate, 23);
};

export const parseFmtDate = (date: string) => {
  let fmtDate = moment(date).format("YYYY-MM-DD");
  if (fmtDate === "Invalid date") {
    const reAssign = moment(date, "DDMMYYYY").format("YYYY-MM-DD");
    fmtDate = reAssign !== "Invalid date" ? reAssign : "";
  }
  return (date && fmtDate) || "";
};
